import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractValueFormulaToken from "./AbstractValueFormulaToken.js";
import AccountFormulaNode from "../formula/AccountFormulaNode.js";
import AccountIntervalSpecification from "../../accountSpecification/AccountIntervalSpecification.js";

/**
 * Value token representing an interval (range) of accounts.
 *
 * @param {string} [spec.start] - Account number of the forst account of the interval.
 * @param {string} [spec.end] - Accoutn number of the last account of the interval.
 */
export default class AccountIntervalFormulaToken extends AbstractValueFormulaToken {
	constructor({ start = "", end = "" } = {}) {
		super(...arguments);
		this._start = start;
		this._end = end;
	}

	getStart() {
		return this._start;
	}

	setStart(start) {
		this._start = start;
	}

	getEnd() {
		return this._end;
	}

	setEnd(end) {
		this._end = end;
	}

	accept(visitor) {
		return visitor.visitAccountIntervalFormulaToken(this);
	}

	_asBaseFormulaNode() {
		return new AccountFormulaNode({
			accountSpecification: new AccountIntervalSpecification({
				interval: `${this._start}-${this._end}`,
			}),
		});
	}

	static getLabel() {
		return _("Interval");
	}

	static getType() {
		return "account-interval";
	}
}
